import { render, staticRenderFns } from "./InputEmail.vue?vue&type=template&id=f8f84a4a"
import script from "./InputEmail.vue?vue&type=script&lang=ts"
export * from "./InputEmail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports